import { useLayoutContext } from 'hellosign/common/layout/context';
import { useLocation } from 'react-router';

export function useSelectedPlanId() {
  const location = useLocation();
  const selectedPlanIdFromLayoutContext =
    useLayoutContext()?.pageProps?.selected_plan_id;
  const selectedPlanIdFromQuery =
    new URLSearchParams(location.search).get('selected_plan_id') ?? undefined;

  return selectedPlanIdFromLayoutContext ?? selectedPlanIdFromQuery;
}
